module.exports = __webpack_public_path__ + "img/logo.bc63c57e.png";